module.exports = __webpack_public_path__ + "img/ml3018.3dd4ca66.png";